var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#222","fillRule":"nonzero","d":"M.315 1.707a.95.95 0 0 1 0-1.414c.421-.39 1.103-.39 1.523 0l4.847 4.5a.95.95 0 0 1 0 1.414l-4.847 4.5c-.42.39-1.102.39-1.523 0a.95.95 0 0 1 0-1.414L4.4 5.5.315 1.707z"}));
}

Arrow.defaultProps = {"width":"7","height":"11","viewBox":"0 0 7 11"};

module.exports = Arrow;

Arrow.default = Arrow;
